/**
 * Calculates the final price of the configuration
 */

export const getFinalPrice = (productsState, itemsState) => {
  // CUSTOM CODE: just need to know which leather class is being used to determine price
  let finalPrice = productsState?.activeObj?.shopify.prices[itemsState?.activeIds?.leather_class?._id] || 0;
  return finalPrice.toFixed(2);
};
